
















import { Component, Vue, Watch } from 'vue-property-decorator';
import TopBar from '@/components/menu/TopBar.vue';
import SideBar from '@/components/menu/SideBar.vue';
import Modal from '@/components/common/Modal.vue';
import { Action, Getter } from 'vuex-class';
import { Utils } from './utils/utils';

@Component({
  components: {
    TopBar,
    SideBar,
    Modal,
  },
})
export default class App extends Vue {
  @Action('ensureUserConnectedAction') public ensureUserConnectedAction!: () => void;
  @Getter public loggedIn!: boolean;
  @Getter public isModalOpened!: boolean;

  // Lifecycle hook
  private mounted() {
    if (!Utils.isLoggedIn()) {
      Utils.toggleBodyClass('addClass', 'bg-dark');
    } else {
      this.ensureUserConnectedAction();
    }
    Utils.ensureAxiosJwtHeaders();
    Utils.intercept401();
  }

  @Watch('loggedIn')
  private onPropertyChanged(value: string, oldValue: string) {
    if (!oldValue && value) {
      this.$router.replace('/user/list');
    }
    Utils.toggleBodyClass(value ? 'removeClass' : 'addClass', 'bg-dark');
  }
}
